export class Config {
    public static readonly teamGroupsShownSeparated = false;
}


// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/shared/config.ts